/* eslint-disable */
// AUTO-GENERATED by scripts/codegen/generate.mjs from wix.isa.pulse_identity.v1 — do not edit.

import { resolveUrl, toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
const _pulseIdentity = {
  createdDate: 'google.protobuf.Timestamp',
  updatedDate: 'google.protobuf.Timestamp'
};
const _createPulseIdentityRequest = {
  pulseIdentity: '_pulseIdentity'
};
const _createPulseIdentityResponse = {
  pulseIdentity: '_pulseIdentity'
};
const _getPulseIdentityRequest = {};
const _getPulseIdentityResponse = {
  pulseIdentity: '_pulseIdentity'
};
const _updatePulseIdentityRequest = {
  pulseIdentity: '_pulseIdentity',
  fieldMask: 'google.protobuf.FieldMask'
};
const _updatePulseIdentityResponse = {
  pulseIdentity: '_pulseIdentity'
};
const _deletePulseIdentityRequest = {};
const _deletePulseIdentityResponse = {};
const _queryPulseIdentitiesRequest = {};
const _queryPulseIdentitiesResponse = {
  pulseIdentities: '_pulseIdentity'
};
const _migrateDefaultOutreachPulseIdentitiesRequest = {};
const _migrateDefaultOutreachPulseIdentitiesResponse = {};
const _descriptors = {
  _pulseIdentity,
  _createPulseIdentityRequest,
  _createPulseIdentityResponse,
  _getPulseIdentityRequest,
  _getPulseIdentityResponse,
  _updatePulseIdentityRequest,
  _updatePulseIdentityResponse,
  _deletePulseIdentityRequest,
  _deletePulseIdentityResponse,
  _queryPulseIdentitiesRequest,
  _queryPulseIdentitiesResponse,
  _migrateDefaultOutreachPulseIdentitiesRequest,
  _migrateDefaultOutreachPulseIdentitiesResponse
};
function resolvePulseIdentityServiceUrl(opts) {
  const domainToMappings = {
    'manage._base_domain_': [{
      srcPath: '/_api/pulse-identity',
      destPath: ''
    }],
    'api._api_base_domain_': [{
      srcPath: '/pulse-identity',
      destPath: ''
    }],
    'www.wixapis.com': [{
      srcPath: '/individual-scheduling-assistant/v1/pulse-identities',
      destPath: '/v1/pulse-identities'
    }],
    '*.dev.wix-code.com': [{
      srcPath: '/individual-scheduling-assistant/v1/pulse-identities',
      destPath: '/v1/pulse-identities'
    }],
    _: [{
      srcPath: '/individual-scheduling-assistant/v1/pulse-identities',
      destPath: '/v1/pulse-identities'
    }]
  };
  return resolveUrl(Object.assign(opts, {
    domainToMappings
  }));
}

/** CreatePulseIdentity. */
export function createPulseIdentity(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_createPulseIdentityRequest, _descriptors);
  const fromRes = serializer(_createPulseIdentityResponse, _descriptors).fromJSON;
  function __createPulseIdentity(_ref) {
    let {
      host
    } = _ref;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_identity',
      method: 'POST',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseIdentityService.CreatePulseIdentity',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseIdentityServiceUrl({
        protoPath: '/v1/pulse-identities',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __createPulseIdentity.fromReq = fromReq;
  __createPulseIdentity.__isAmbassador = true;
  return __createPulseIdentity;
}

/** GetPulseIdentity. */
export function getPulseIdentity(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getPulseIdentityRequest, _descriptors);
  const fromRes = serializer(_getPulseIdentityResponse, _descriptors).fromJSON;
  function __getPulseIdentity(_ref2) {
    let {
      host
    } = _ref2;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_identity',
      method: 'GET',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseIdentityService.GetPulseIdentity',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseIdentityServiceUrl({
        protoPath: '/v1/pulse-identities/{pulse_identity_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __getPulseIdentity.fromReq = fromReq;
  __getPulseIdentity.__isAmbassador = true;
  return __getPulseIdentity;
}

/** UpdatePulseIdentity. */
export function updatePulseIdentity(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_updatePulseIdentityRequest, _descriptors);
  const fromRes = serializer(_updatePulseIdentityResponse, _descriptors).fromJSON;
  function __updatePulseIdentity(_ref3) {
    let {
      host
    } = _ref3;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_identity',
      method: 'PATCH',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseIdentityService.UpdatePulseIdentity',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseIdentityServiceUrl({
        protoPath: '/v1/pulse-identities/{pulse_identity.id}',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __updatePulseIdentity.fromReq = fromReq;
  __updatePulseIdentity.__isAmbassador = true;
  return __updatePulseIdentity;
}

/** DeletePulseIdentity. */
export function deletePulseIdentity(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_deletePulseIdentityRequest, _descriptors);
  const fromRes = serializer(_deletePulseIdentityResponse, _descriptors).fromJSON;
  function __deletePulseIdentity(_ref4) {
    let {
      host
    } = _ref4;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_identity',
      method: 'DELETE',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseIdentityService.DeletePulseIdentity',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseIdentityServiceUrl({
        protoPath: '/v1/pulse-identities/{pulse_identity_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __deletePulseIdentity.fromReq = fromReq;
  __deletePulseIdentity.__isAmbassador = true;
  return __deletePulseIdentity;
}

/** QueryPulseIdentities. */
export function queryPulseIdentities(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_queryPulseIdentitiesRequest, _descriptors);
  const fromRes = serializer(_queryPulseIdentitiesResponse, _descriptors).fromJSON;
  function __queryPulseIdentities(_ref5) {
    let {
      host
    } = _ref5;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_identity',
      method: 'POST',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseIdentityService.QueryPulseIdentities',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseIdentityServiceUrl({
        protoPath: '/v1/pulse-identities/query',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes,
      fallback: [{
        method: 'POST',
        url: resolvePulseIdentityServiceUrl({
          protoPath: '/v1/pulse-identities/query',
          data: serializedData,
          host
        }),
        data: serializedData
      }, {
        method: 'GET',
        url: resolvePulseIdentityServiceUrl({
          protoPath: '/v1/pulse-identities/query',
          data: serializedData,
          host
        })
      }]
    };
  }
  __queryPulseIdentities.fromReq = fromReq;
  __queryPulseIdentities.__isAmbassador = true;
  return __queryPulseIdentities;
}

/** MigrateDefaultOutreachPulseIdentities. */
export function migrateDefaultOutreachPulseIdentities(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_migrateDefaultOutreachPulseIdentitiesRequest, _descriptors);
  const fromRes = serializer(_migrateDefaultOutreachPulseIdentitiesResponse, _descriptors).fromJSON;
  function __migrateDefaultOutreachPulseIdentities(_ref6) {
    let {
      host
    } = _ref6;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_identity',
      method: 'POST',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseIdentityService.MigrateDefaultOutreachPulseIdentities',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseIdentityServiceUrl({
        protoPath: '/v1/pulse-identities/migrate-default-outreach',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __migrateDefaultOutreachPulseIdentities.fromReq = fromReq;
  __migrateDefaultOutreachPulseIdentities.__isAmbassador = true;
  return __migrateDefaultOutreachPulseIdentities;
}
//# sourceMappingURL=pulseIdentityHttpRequests.js.map